import clsx from 'clsx';
import React from 'react';

interface ITextArea {
  id?: string;
  placeholder?: string;
  onChange?: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  value?: string;
  error?: boolean;
}
export default function TextArea({
  id,
  placeholder,
  onChange,
  value,
  error,
}: ITextArea) {
  return (
    <textarea
      id={id}
      className={clsx(
        'border rounded-6 placeholder:font-semibold text-primary placeholder:text-gray py-2.5 outline-0 bg-white  px-3 w-full resize-none h-[100px] block',
        error ? 'border-red' : 'border-borderColor'
      )}
      placeholder={placeholder}
      onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) =>
        onChange ? onChange(e) : null
      }
      value={value}
    />
  );
}
